/* eslint-disable @typescript-eslint/naming-convention */
import { EstablishmentDto } from "../services/api";

// ISO 4217 currency codes
export const MAP_CURRENCY_TO_ISO: { [key in EstablishmentDto.CurrencyEnum]: string } = {
  BRITISHPOUND: "GBP",
  EURO: "EUR",
  UNITEDSTATESDOLLAR: "USD",
};
